module.exports = __webpack_public_path__ + "img/img15.8e6c521f.png";